const customSessionStorage = {
    clear: ()=>{
        try {
            window.sessionStorage.clear();
        } catch (error) {
            console.error('CustomSessionStorage: Error to clear the sessionStorage', error);
        }
    },
    getItem: (key)=>{
        try {
            return window.sessionStorage.getItem(key);
        } catch (error) {
            console.error(`CustomSessionStorage: Error to get the value for the key ${key}`, error);
            return null;
        }
    },
    removeItem: (key)=>{
        try {
            window.sessionStorage.removeItem(key);
        } catch (error) {
            console.error(`CustomSessionStorage: Error to remove the value for the key ${key}`, error);
        }
    },
    setItem: (key, value)=>{
        try {
            window.sessionStorage.setItem(key, value);
        } catch (error) {
            console.error(`CustomSessionStorage: Error to set the value for the key ${key}`, error);
        }
    }
};
const src_customSessionStorage = customSessionStorage;
export default src_customSessionStorage;
